import axios from "axios";
import { useEffect, useReducer, useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { Fetch } from "./Fetch";

const initialState = {
  dataRes: [],
  loadingRes: true,
  errorRes: null,
};

const ACTION = {
  API_REQUEST: "api-request",
  FETCH_DATA: "fetch-data",
  ERROR: "error",
};

function reducer(state, { type, payload }) {
  switch (type) {
    case ACTION.API_REQUEST:
      return { ...state, loading: true, error: null };
    case ACTION.FETCH_DATA:
      return {
        ...state,
        data: payload,
        loading: false,
      };
    case ACTION.ERROR:
      return { ...state, loading: false, error: payload };
    default:
      return state;
  }
}

function useDelete(url, go, page, setNewData, FetchUrl, newObject, setDeleted) {
  const navigate = useNavigate();
  const [state, dispatch] = useReducer(reducer, initialState);
  const [loading, setLoading] = useState(false);
  useEffect(() => {
    if (go) {
      setLoading(true);
      dispatch({ type: ACTION.API_REQUEST });
      axios
        .delete(
          url,
          newObject
            ? {
                withCredentials: true,
                headers: {
                  "Content-Type": "application/json",
                  Accept: "application/app.js",
                },
                data: newObject,
              }
            : {
                withCredentials: true,
                headers: {
                  "Content-Type": "application/json",
                  Accept: "application/app.js",
                },
              }
        )
        .then((res) => {
          dispatch({ type: ACTION.FETCH_DATA, payload: res?.data });
          setLoading(false);
          toast.success("Deleted Successfully", {
            position: "top-right",
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnFocusLoss: false,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
          });
          // if (setNewData) Fetch(FetchUrl ?? url, setNewData);
          if (page) navigate(`/${page}`);
          if (setDeleted) setDeleted("");
        })
        .catch((err) => {
          dispatch({ type: ACTION.ERROR, payload: err.error });
          setLoading(false);
          toast.error(err.response?.data?.message, {
            position: "top-right",
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnFocusLoss: false,
            draggable: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
          });
          if (setDeleted) setDeleted("");
        });
    }
  }, [go]);

  return { state, loading };
}

export default useDelete;
